const HELPER_TEXT_FIELD_KEY = "input";
const HELPER_TEXT_AREA_KEY = "textarea";
const HELPER_RADIO_KEY = "radio";
const HELPER_SELECT_KEY = "select";
const HELPER_CHECKBOX_KEY = "checkbox";

const CUSTOM_TEXT_FIELD_COMPONENT_NAME = "CustomTextField";
const CUSTOM_TEXT_AREA_COMPONENT_NAME = "CustomTextArea";
const CUSTOM_RADIO_COMPONENT_NAME = "CustomRadio";
const CUSTOM_SELECT_COMPONENT_NAME = "CustomSelect";
const CUSTOM_CHECKBOX_KEY = "CustomCheckbox";

export default {
  HELPER_TEXT_FIELD_KEY,
  HELPER_TEXT_AREA_KEY,
  HELPER_RADIO_KEY,
  HELPER_SELECT_KEY,
  HELPER_CHECKBOX_KEY,
  CUSTOM_TEXT_FIELD_COMPONENT_NAME,
  CUSTOM_TEXT_AREA_COMPONENT_NAME,
  CUSTOM_RADIO_COMPONENT_NAME,
  CUSTOM_SELECT_COMPONENT_NAME,
  CUSTOM_CHECKBOX_KEY
}
